"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const styled_components_1 = __importDefault(require("styled-components"));
const ImageAnnotations_1 = require("../ImageAnnotations");
const SketchAnnotations_1 = require("../SketchAnnotations");
const TextAnnotations_1 = require("../TextAnnotations");
const VideoAnnotations_1 = require("../VideoAnnotations");
function AnnotationsItems({ stickies, isFullscreen, onFullscreen, }) {
    return ((0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'AnnotationsItems_Container', children: (0, jsx_runtime_1.jsx)(AnnotationsItemsList, { "$isFullscreen": isFullscreen, "data-e2e": 'AnnotationsItems_AnnotationsItemsList', children: stickies === null || stickies === void 0 ? void 0 : stickies.map(({ image, text, identifier, curves, videoLink, type }) => {
                if (type === bridge_schema_1.ToolType.StickyHandWriting && curves !== undefined) {
                    return ((0, jsx_runtime_1.jsx)(SketchAnnotations_1.SketchAnnotations, { curves: curves, onFullscreen: onFullscreen, "data-e2e": 'AnnotationsItems_SketchAnnotations' }, identifier));
                }
                if (type === bridge_schema_1.ToolType.StickyVideo &&
                    image !== undefined &&
                    videoLink !== undefined) {
                    return ((0, jsx_runtime_1.jsx)(VideoAnnotations_1.VideoAnnotations, { identifier: identifier, videoLink: videoLink, image: image || '', onFullscreen: onFullscreen, "data-e2e": 'AnnotationsItems_VideoAnnotations' }, identifier));
                }
                if (type === bridge_schema_1.ToolType.StickyText && text !== undefined) {
                    return ((0, jsx_runtime_1.jsx)(TextAnnotations_1.TextAnnotations, { text: text, onFullscreen: onFullscreen, "data-e2e": 'AnnotationsItems_TextAnnotations' }, identifier));
                }
                if (type === bridge_schema_1.ToolType.StickyImage && image !== undefined) {
                    return ((0, jsx_runtime_1.jsx)(ImageAnnotations_1.ImageAnnotations, { imageUrl: image, onFullscreen: onFullscreen, "data-e2e": 'AnnotationsItems_ImageAnnotations' }, identifier));
                }
                return null;
            }) }) }));
}
exports.default = AnnotationsItems;
const Container = styled_components_1.default.div `
  padding-right: 4px;
  height: 100%;
  width: 100%;
  position: relative;
`;
const AnnotationsItemsList = styled_components_1.default.div `
  padding: 4px 8px 4px 0;
  height: 100%;
  display: flex;

  flex-wrap: wrap;
  justify-content: center;

  gap: 16px;
  box-sizing: border-box;
  overflow-y: ${({ $isFullscreen }) => ($isFullscreen ? 'visible' : 'auto')};
  overflow-x: ${({ $isFullscreen }) => ($isFullscreen ? 'visible' : 'hidden')};
  position: relative;

  &::after {
    content: '';
    flex: 0 0 304px;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }
`;
